import { swipeData } from "../../../projectSpecific/thumbstat/swipeData"
import { courtSectors } from "../../components/svg/sectors"
import { svgElementProps, svgTypes } from "../../components/svg/svgElements"
import { swipeDivs } from "../../components/swipe/swipeDivs"
import { thumbTouch } from "../../components/swipe/ThumbTouch"

const tickMargin = 10
const allowUpdate = true

// const usePerc = false

export const rts = {
  handleInit_thumbSwipe: 'handleInit_thumbSwipe',
  handleFinish: 'handleFinish',
  getZoneStatElements: 'getZoneStatElements',
  handleDisplayItem: 'handleDisplayItem',
  handleDiv: 'handleDiv',
  handleSvgElement: 'handleSvgElement',
  handleSvgType: 'handleSvgType',
  handleTouchEnd: 'handleTouchEnd',
  handleTouchMove: 'handleTouchMove',
  handleTouchStart: 'handleTouchStart',
  handleSet_currentElements: 'handleSet_currentElements',
  handleReset: 'handleReset',
  // handleAmmend_thumbTouch: 'handleAmmend_thumbTouch',
}

export const thumbSwipeReducer = (state, action) => {

  const { svgType, isTouching, thumbTouch, actionLineColor, thisCourt, settings } = state
  const { type, touchEvent, dispatch, swipeHolder } = action

  let _touch = thumbTouch.touch

  const { handleFinish, handleSvgElement } = thumbSwipeHandlers(dispatch)

  switch (type) {

    case rts.handleInit_thumbSwipe:
      return { ...state, ...action.initState }

    // case rts.handleAmmend_thumbTouch:
    //   return { ...state, thumbTouch: action.thumbTouch }

    case rts.handleDiv:
      // top AND bottom
      // if (swipeType === 'swipe') {
      //   swipeArea = (statView.swipeArea) ? statView.swipeArea : state.statGroupStatItem.swipeArea
      // }
      return { ...state, swipeDiv: action.swipeDiv.current }

    case rts.handleSvgType:
      return { ...state, svgType: action.svgType }

    case rts.handleReset:
      return { ...state, lastActionElement: null, done: false }

    case rts.handleDisplayItem:
      return { ...state, displayItem: action.displayItem }

    case rts.handleSet_currentElements:
      return { ...state, currentSvgElements: action.currentElements }

    case rts.handleSvgElement:

      let _elem;

      switch (svgType) {
        case svgTypes.line:
          _elem = svgElementProps.line(_touch.line(), 10, actionLineColor, true)
          break;

        case svgTypes.rectangle:
          _elem = svgElementProps.rect(_touch.rect(), 'blue')
          break;

        case svgTypes.circle:
          _elem = svgElementProps.circle(_touch.circle(), 'blue')
          break;

        default:
        // nothing
      }
      return { ...state, currentElem: _elem, lastActionElement: _elem }

    case rts.handleTouchStart:

      let os = state.swipeDiv.getBoundingClientRect();

      _touch.offsetLeft = os?.left
      _touch.offsetTop = os?.top

      const { ok, groupColor, actionLineColor: alc, resultGroupItemName } = thumbTouch.sectors ? thumbTouch.courtData(true, thisCourt.maxHeight) : { ok: true }

      const { clientX, clientY, isTouch, isMouse } = getCoords(touchEvent)

      _touch.touchStartX = clientX;
      _touch.touchStartY = clientY;
      _touch.isTouch = isTouch
      _touch.isMouse = isMouse

      if (ok) {
        if (settings.allowHolder) {
          return { ...state, isTouching: true, done: false, totalDuration: 0 }
        } else {
          return { ...state, isTouching: true, done: false, totalDuration: 0, timerTotal: setInterval(state.tock, 50) }
        }
      }

      return { ...state }

    case rts.handleTouchMove:

      if (isTouching) {
        if (_touch.isTouch || _touch.isMouse) {

          const { clientX, clientY } = getCoords(touchEvent)

          if (clientX && clientY) {

            // }
            // if (touchEvent.touches && touchEvent.touches[0]) {

            let tempDiffX = Math.abs(_touch.touchNowX - clientX)
            let tempDiffY = Math.abs(_touch.touchNowY - clientY)

            // allow some movement to the touch hold
            if (settings.allowHolder) {
              if (tempDiffX < tickMargin && tempDiffY < tickMargin) {
                clearInterval(state.timer);
                // this.duration = 0
                // this.timer = setInterval(this.tick, 10);
              }
            }

            _touch.touchNowX = clientX
            _touch.touchNowY = clientY

            // reset the timer if moved 
            _touch.moveDiffX = Math.abs(_touch.touchStartX - _touch.touchNowX)
            _touch.moveDiffY = Math.abs(_touch.touchStartY - _touch.touchNowY)

            if (_touch.direction === 'n') {
              if (_touch.moveDiffX > _touch.moveDiffY) {
                _touch.direction = 'h'
              } else {
                _touch.direction = 'v'
              }
            }

            if (_touch.touchNowY <= _touch.touchStartY) {
              _touch.up = true
            } else {
              _touch.up = false
            }

            handleSvgElement()
            if (thumbTouch.sectors) {
              const { ok, groupColor, actionLineColor: alc, resultGroupItemName } = thumbTouch.courtData(false, thisCourt.maxHeight)
              return { ...state, done: false, actionLineColor: alc }
            }
          }
        } else if (_touch.isMouse) {

        }
      }

      return { ...state, done: false }

    case rts.handleTouchEnd:
      if (isTouching) {
        clearInterval(state.timer);
        clearInterval(state.timerTotal)
        handleFinish()
        return { ...state, timerOn: false, done: true }
      } else {
        return { ...state }
      }

    case rts.handleFinish:

      let touchD = thumbTouch.touchData

      let newResult = touchD.csr.swipeResult
      let timerOn;


      if (swipeHolder) {
        newResult = swipeHolder
        touchD.actionLineColor = touchD.csr.color
        timerOn = false
        clearInterval(state.timer);
        clearInterval(state.timerTotal)
        touchD.csr.swipeResult = swipeHolder
      }

      // if (thumbTouch.swipeData && thumbTouch.swipeData.resultItems.slowers && thumbTouch.swipeData.resultItems.slowers[thumbTouch.touchData.csr.resultItems]) {
      //   if (state.totalDuration > 25) {
      //     newResult = thumbTouch.swipeData.resultItems.slowers[thumbTouch.touchData.csr.swipeResult]
      //   }
      // }

      // if (thumbTouch.swipeData) { updateSwipeProps(state, newResult) }

      // let actionElements = state.currentLines
      // actionElements = []
      // actionElements.push(actionElements)

      return {
        ...state,
        isTouching: false,
        done: true,
        timerOn,
        actionLineColor: 'black',
        courtOuterColor: 'grey',
        statView: null,
        statGroupStatItem: null
      }

    default:
      return { ...state }
  }
}

export const thumbSwipeInitialState = (initState) => {

  const { imageStyle, statCategory, tss, props, useSectors } = initState ?? {}

  const touchData = {}
  const _thumbTouch = thumbTouch

  const thisCourt = swipeDivs.courtSwipe

  if (useSectors) {
    const sectors = courtSectors(200, thisCourt)
    _thumbTouch.sectors = sectors
    const _swipeData = swipeData
    _thumbTouch.swipeData = _swipeData
  }

  const _state = {
    isTouching: false,
    swipeType: initState.swipeType,
    statCategory,
    tss,

    // statGroup and statView are the same if action not seleted 
    statGroup: tss ? tss.statGroup : null,
    statView: tss ? tss.statView : null,

    settings: {
      allowSwipe: tss ? tss.allowSwipeHold : false,
      colors: statCategory ? statCategory.colors : null,
      icons: statCategory ? statCategory.icons : null,
      handlers: tss ? tss.handlers : null,
      styleHeights: props ? props.styleHeights : {}
    },

    sectors: null,

    // category specific
    rotation: null,

    // from parent
    player: props ? props.player : null,

    // from parent via
    matchData: statCategory ? statCategory.matchData : null,
    statGroupStatItem: tss ? tss.statGroupStatItem : null, // NEED

    action: (tss && tss.statGroupStatItem && tss.statGroupStatItem.requestItems.action) ? tss.statGroupStatItem.requestItems.action : null,

    currentElem: null,

    actionPlayElements: [],

    zoneStatElements: {
      pass: [],
      oppAttack: []
    },

    touchData: touchData,
    actionLineColor: 'black',
    courtOuterColor: 'black',

    next: '--',

    elapsed: 0,
    duration: 0,
    totalDuration: 0,
    maxCourtHeight: thisCourt ? thisCourt.maxHeight : 0,

    lastActionElement: null,
    resultGroupItemName: null,
    statGroupItem: null,
    groupColor: null,

    courtSVG: null,
    thisCourt,
    imageStyle,

    categorySVGProps: {}
  }

  _thumbTouch.parent = _state
  _state.thumbTouch = _thumbTouch

  return _state

};

export const thumbSwipeHandlers = (dispatch, state) => {
  return {
    handleInit_thumbSwipe: (initState) => { dispatch({ type: rts.handleInit_thumbSwipe, initState }) },
    // handleAmmend_thumbTouch: (thumbTouch) => { dispatch({ type: rts.handleAmmend_thumbTouch, thumbTouch }) },
    handleSet_currentElements: (currentElements) => { dispatch({ type: rts.handleSet_currentElements, currentElements }) },
    getZoneStatElements: () => { dispatch({ type: rts.getZoneStatElements }) },
    handleDisplayItem: (displayItem) => { dispatch({ type: rts.handleDisplayItem, displayItem }) },
    handleDiv: (swipeDiv) => { dispatch({ type: rts.handleDiv, swipeDiv }) },
    handleFinish: (isEOP, swipeHolder) => { dispatch({ type: rts.handleFinish, isEOP, swipeHolder }) },
    handleReset: () => { dispatch({ type: rts.handleReset }) },
    handleSvgElement: (isEnd) => { dispatch({ type: rts.handleSvgElement, isEnd }) },
    handleSvgType: (svgType) => { dispatch({ type: rts.handleSvgType, svgType }) },
    handleTouchEnd: (touchEvent) => { dispatch({ type: rts.handleTouchEnd, touchEvent, dispatch }) },
    handleTouchMove: (touchEvent) => { dispatch({ type: rts.handleTouchMove, touchEvent, dispatch }) },
    handleTouchStart: (touchEvent) => { dispatch({ type: rts.handleTouchStart, touchEvent, dispatch }) },
  }
}

const updateSwipeProps = (state, newResult) => {

  let updateIsGood = true

  const { thumbTouch, settings, thisCourt } = state
  let touchD = thumbTouch.touchData

  let swipeProps = { details: {} }

  Object.keys(thumbTouch.swipeData.requestItems).forEach(key => {
    switch (key) {
      case 'action':
        swipeProps[key] = state.action
        break;
      case 'zone':
        swipeProps[key] = touchD.current.zone
        break;
      case 'swipeResult':
        swipeProps[key] = newResult
        break;
      case 'xtra':
        swipeProps[key] = touchD.csr.xtra
        break;
      default:
      // nothing
    }
  })

  // touchD.current
  swipeProps.details['movement'] = touchD.movement(state.sectors.maxCourtWidth, thisCourt.maxHeight, touchD)
  if (touchD.dipped) { swipeProps['dipped'] = touchD.dipped }

  if (thumbTouch.swipeData) {
    Object.keys(thumbTouch.swipeData.requestItems).forEach(key => {
      if (key !== 'xtra') {
        if (!thumbTouch.swipeData.requestItems[key] || thumbTouch.swipeData.requestItems[key] === '---') {
          console.log('NOT GOOD' + key)
          updateIsGood = false
        }
      }
    })
  }

  if (allowUpdate && updateIsGood && !touchD.areasSame()) {
    settings.handlers.updateSwipeAction(swipeProps)
  }
}

const getCoords = (touchEvent) => {

  let clientX;
  let clientY;
  let isTouch;
  let isMouse;

  if (touchEvent.touches && touchEvent.touches[0]) {
    clientX = touchEvent.touches[0].clientX;
    clientY = touchEvent.touches[0].clientY;
    isTouch = (touchEvent.touches);
  } else {
    clientX = touchEvent.clientX ? touchEvent.clientX : window.event.clientX;
    clientY = touchEvent.clientY ? touchEvent.clientY : window.event.clientY;
    isMouse = true
  }

  return { clientX, clientY, isTouch, isMouse }
}